import React from 'react';
import Header, { HeaderLeft } from '../../../layout/Header/Header';
import CommonHeaderRight from './CommonHeaderRight';

const RequestedHabitMassageCenterHeader = () => {
	return (
		<Header>
			<HeaderLeft className='h4 mb-0 fw-bold'>Requested Habit Massage Center</HeaderLeft>
			<CommonHeaderRight />
		</Header>
	);
};

export default RequestedHabitMassageCenterHeader;
